module.exports = __webpack_public_path__ + "static/media/Marotte_Chene_aurea_MT2-15-Scale.e06227c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/Marotte_Chene_aurea_MT2-15-Scale.jpg
// module id = 950
// module chunks = 37